;(function() {
  'use strict'

  angular.module('core.questionTemplates', [])
})()
